import { render, staticRenderFns } from "./materialCustomer.vue?vue&type=template&id=dc8c5f72&scoped=true"
import script from "./materialCustomer.vue?vue&type=script&lang=js"
export * from "./materialCustomer.vue?vue&type=script&lang=js"
import style0 from "./materialCustomer.vue?vue&type=style&index=0&id=dc8c5f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8c5f72",
  null
  
)

export default component.exports